var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.608398,
    y: 0.515625,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F27405",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2284 21.5156C40.9284 21.5156 41.508 21.7396 42.012 22.1736L42.1982 22.3458L48.7782 28.9258C49.2654 29.413 49.5426 29.9688 49.5986 30.6394L49.6084 30.8956V40.1356C49.6084 40.8356 49.3844 41.4152 48.9504 41.9192L48.7782 42.1054L42.1982 48.6854C41.711 49.1726 41.1552 49.4498 40.4846 49.5058L40.2284 49.5156H30.9884C30.2884 49.5156 29.7088 49.2916 29.2048 48.8576L29.0186 48.6854L22.4386 42.1054C21.9514 41.6182 21.6742 41.0624 21.6182 40.3918L21.6084 40.1356V30.8956C21.6084 30.1956 21.8324 29.616 22.2664 29.112L22.4386 28.9258L29.0186 22.3458C29.5058 21.8586 30.0616 21.5814 30.7322 21.5254L30.9884 21.5156H40.2284ZM35.6224 39.7156L35.4446 39.7254C34.7403 39.8092 34.21 40.4064 34.21 41.1156C34.21 41.8249 34.7403 42.4221 35.4446 42.5058L35.6084 42.5156L35.7862 42.5058C36.4905 42.4221 37.0208 41.8249 37.0208 41.1156C37.0208 40.4064 36.4905 39.8092 35.7862 39.7254L35.6224 39.7156ZM35.6084 28.5156C34.8986 28.5157 34.3012 29.0469 34.2182 29.7518L34.2084 29.9156V35.5156L34.2182 35.6794C34.302 36.3837 34.8992 36.9141 35.6084 36.9141C36.3176 36.9141 36.9148 36.3837 36.9986 35.6794L37.0084 35.5156V29.9156L36.9986 29.7518C36.9156 29.0469 36.3182 28.5157 35.6084 28.5156Z",
    fill: "#F27405"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.6d68f9d7ce97b10679de7d2625917461.svg";
export { ForwardRef as ReactComponent };